module.exports = __webpack_public_path__ + "img/wallet.65fea928.svg";